module.exports = __webpack_public_path__ + "static/img/chat-logo.1e2b633c.png";